import { SARLogHttpService } from "@/services/httpService"

export class DownloadsService extends SARLogHttpService {
	constructor() {
		super("/api/download")
	}

	async generateLink(uploadGuid: string) {
		return await this.returning(String).post("generate-link", uploadGuid)
	}
}
